import {Component, Input, OnInit} from '@angular/core';
import {CronOptions} from 'cron-editor/lib/CronOptions';

@Component({
  selector: 'ap-automation-setup',
  templateUrl: './manage-automation.component.html',
  styleUrls: ['./manage-automation.component.scss']
})
export class ManageAutomationComponent implements OnInit {

  @Input() externalTestsuiteConfigs: any;

  componentLoading = false;
  selectedTab = 0;


  @Input() executionCommands = '';

  constructor() { }

  ngOnInit() {
  }

  tabChanged(event) {
    this.selectedTab = event.index;
  }
}
